import { render, staticRenderFns } from "./OrderProducts.vue?vue&type=template&id=5027bc1d&scoped=true&"
import script from "./OrderProducts.vue?vue&type=script&lang=js&"
export * from "./OrderProducts.vue?vue&type=script&lang=js&"
import style0 from "./OrderProducts.vue?vue&type=style&index=0&id=5027bc1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5027bc1d",
  null
  
)

export default component.exports